
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TeamModel } from './Identity.Api.Models.Team';
import { UserModel } from './Identity.Api.Models.User';
import { Model, ModelProperty } from 'models/Model';


export class UserTeamModel extends Model<UserTeamModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'created', type: 'Date', isHidden: true },
		{ name: 'deleted', type: 'Date', isHidden: true },
		{ name: 'userId', type: 'string' },
		{ name: 'teamId', type: 'string' },
		{ name: 'team', type: 'TeamModel', isHidden: true, isObject: true, new: () => { return new TeamModel }, properties: () => { return TeamModel.classProperties } },
		{ name: 'user', type: 'UserModel', isHidden: true, isObject: true, new: () => { return new UserModel }, properties: () => { return UserModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public created?: Date;
	public deleted?: Date;
	public userId?: string;
	public teamId?: string;
	public team?: TeamModel;
	public user?: UserModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.created = undefined;
		this.deleted = undefined;
		this.userId = undefined;
		this.teamId = undefined;
		this.team = undefined;
		this.user = undefined;
		
	}
	getProperties(){
		return UserTeamModel.classProperties;
	}
}

